// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"c57dded8","377":"ae4dc834","513":"4a95e60f","606":"91f2a0bf"}[chunkId] + ".chunk.js";
};